// ADR-110 — pure helpers for the Bench Report's Position facet.

/**
 * ADR-110 §2.3: selected positions are kept when nobody in scope holds them (shown with 0);
 * only ids the server reports as not found (deleted positions) are dropped.
 *
 * Acts only on ids the facet answered for, so a selection made while the request was in
 * flight is never dropped by a stale answer.
 *
 * @param {Object|null} facet - `positions` block of the facets response
 * @param {string[]} selectedPositionIds - current selection
 * @returns {string[]|null} the pruned selection, or null when nothing changes
 */
export const pruneMissingSelectedPositions = (facet, selectedPositionIds) => {
  if (!facet || !Array.isArray(facet.selected) || !Array.isArray(selectedPositionIds) || selectedPositionIds.length === 0) {
    return null;
  }
  const missing = new Set(facet.selected.filter((entry) => entry && entry.found === false).map((entry) => entry.id));
  if (missing.size === 0) {
    return null;
  }
  const next = selectedPositionIds.filter((id) => !missing.has(id));
  return next.length === selectedPositionIds.length ? null : next;
};

/**
 * Footer note of the Position dropdown: individuals the options cannot select.
 * @param {Object|null} facet
 * @returns {string|null}
 */
export const getPositionFacetFooterNote = (facet) => {
  const count = facet?.withoutPositionCount || 0;
  if (count <= 0) {
    return null;
  }
  return count === 1 ? '1 individual without a position' : `${count} individuals without a position`;
};

/**
 * Count shown next to a position option or a group header.
 * @param {Object} item - facet position or group ({ count })
 * @returns {number|null}
 */
export const getPositionFacetCount = (item) => (item && typeof item.count === 'number' ? item.count : null);
